"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Template = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _nanoid = require("nanoid");

var _Star = _interopRequireDefault(require("@lt/components/icons-react/userflow/Star"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Template = function Template(_ref) {
  var label = _ref.label,
      icon = _ref.icon,
      stars = _ref.stars,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(Content, null, icon && /*#__PURE__*/_react["default"].createElement(_styles.IconContainer, null, typeof icon === 'string' ? /*#__PURE__*/_react["default"].createElement(Icon, {
    src: icon,
    alt: label
  }) : icon), /*#__PURE__*/_react["default"].createElement(_styles.ContainerText, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_styles.LabelText, null, label), !!stars && /*#__PURE__*/_react["default"].createElement(StarsBlock, null, _toConsumableArray(Array(stars)).map(function () {
    return /*#__PURE__*/_react["default"].createElement(StyledStarIcon, {
      key: "".concat(label, "-").concat((0, _nanoid.nanoid)())
    });
  }))), /*#__PURE__*/_react["default"].createElement(Subtitle, null, children)));
};

exports.Template = Template;

var StarsBlock = _styledComponents["default"].div.withConfig({
  displayName: "Template__StarsBlock",
  componentId: "sc-11czz0d-0"
})(["display:inline-block;margin-left:4px;"]);

var StyledStarIcon = (0, _styledComponents["default"])(_Star["default"]).withConfig({
  displayName: "Template__StyledStarIcon",
  componentId: "sc-11czz0d-1"
})(["fill:#ffd600;width:8px;height:8px;"]);

var Icon = _styledComponents["default"].img.withConfig({
  displayName: "Template__Icon",
  componentId: "sc-11czz0d-2"
})(["width:16px;height:16px;"]);

var Content = (0, _styledComponents["default"])(_styles.TitleBlock).withConfig({
  displayName: "Template__Content",
  componentId: "sc-11czz0d-3"
})(["padding:8px;"]);
var Subtitle = (0, _styledComponents["default"])(_styles.SubtitleBlock).withConfig({
  displayName: "Template__Subtitle",
  componentId: "sc-11czz0d-4"
})(["color:#4d4d4d;"]);